<template>
  <span
    class="inline-flex rounded-md shadow-sm select-none"
    @click="emitClick"
  >
    <div
      type="button"
      :class="getClasses"
      class="inline-flex items-center justify-center border  text-sm leading-4 font-medium rounded-md focus:outline-none
      focus:border-blue-300 focus:shadow-outline-blue  transition ease-in-out duration-150 w-full text-center"
    >
      <div v-if="!loading">
        {{ text }}
      </div>
      <div
        v-else
        class="-mt-1"
      >
        <LoadingSpinner :white="false" />
      </div>
    </div>
  </span>
</template>

<script>
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';

export default {

  components: {
    LoadingSpinner,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getClasses() {
      let classes = '';

      if (this.disabled) {
        classes += 'bg-gray-100 border-gray-200 text-gray-500 ';
      } else {
        classes += 'bg-white border-gray-300 text-gray-700 hover:text-gray-500 cursor-pointer ';
      }

      if (this.padding !== undefined) {
        classes += `${this.padding} `;
      } else {
        classes += 'px-3 py-2 ';
      }

      return classes;
    },
  },

  methods: {
    emitClick() {
      if (!this.disabled && !this.loading) {
        this.$emit('click');
      }
    },
  },
};
</script>
